import i18n from '../../i18n/config';

export const getMessages = () => ({
  SUCCESS: {
    SAVED: i18n.t('scheduling.form.messages.saved'),
    DELETED: i18n.t('scheduling.form.messages.deleted'),
  },
  ERROR: {
    SAVE_FAILED: i18n.t('scheduling.form.messages.saveFailed'),
    DELETE_FAILED: i18n.t('scheduling.form.messages.deleteFailed'),
  },
  CONFIRM: {
    DELETE: i18n.t('scheduling.form.messages.confirmDelete'),
  },
  BUTTON: {
    SAVE: i18n.t('scheduling.form.buttons.save'),
    SAVING: i18n.t('scheduling.form.buttons.saving'),
    DELETE: i18n.t('scheduling.form.buttons.delete'),
    DELETING: i18n.t('scheduling.form.buttons.deleting'),
  },
});

export const getSectionTitles = () => ({
  WORK_HOURS: i18n.t('scheduling.form.sections.workHours'),
  WEEKEND_HOLIDAYS: i18n.t('scheduling.form.sections.weekendHolidays'),
});

export const getLabels = () => ({
  START: i18n.t('scheduling.form.labels.start'),
  END: i18n.t('scheduling.form.labels.end'),
  MINUTE: i18n.t('scheduling.form.labels.minute'),
  SKIP_WEEKENDS: i18n.t('scheduling.form.labels.skipWeekends'),
  SKIP_HOLIDAYS: i18n.t('scheduling.form.labels.skipHolidays'),
  COUNTRY_LABEL: i18n.t('scheduling.form.labels.countryLabel'),
  SELECT_COUNTRY: i18n.t('scheduling.form.labels.selectCountry'),
});
